/* Size labels and size carryover between the existing color-product links. */
(function () {
  'use strict';
  if (!window.theme || !theme.jQuery) return;
  theme.jQuery(function () {
    document.querySelectorAll('[data-yfb-size-product]').forEach(function (data) {
      var section = document.getElementById('ProductSection-' + data.dataset.sectionId);
      var form = section && section.querySelector('.product-single__form');
      if (!form || form.dataset.yfbSizeSelection) return;
      var names = JSON.parse(data.textContent);
      var sizeIndex = names.findIndex(function (name) { return name.toLowerCase() === 'size'; });
      var size = form.querySelector('select[data-index="option' + (sizeIndex + 1) + '"]');
      var variantData = document.getElementById('VariantsJson-' + data.dataset.sectionId);
      if (sizeIndex < 0 || !size || !variantData) return;
      form.dataset.yfbSizeSelection = 'true';
      var variants = JSON.parse(variantData.textContent);
      var requested = new URL(location.href).searchParams.get('yfb_size');
      var payment = form.querySelector('.shopify-payment-button');
      var paymentWasHidden = payment && payment.hidden;
      var links = Array.from(section.querySelectorAll('.custom-cross-prod a[data-yfb-color-variants]')).map(function (link) {
        return {
          element: link,
          url: link.href,
          sizeIndex: JSON.parse(link.dataset.yfbColorOptions).findIndex(function (name) { return name.toLowerCase() === 'size'; }),
          variants: JSON.parse(link.dataset.yfbColorVariants)
        };
      });
      function matches(variant, value) {
        return names.every(function (_, index) {
          if (index === sizeIndex) return variant.options[index] === value;
          var input = form.querySelector('select[data-index="option' + (index + 1) + '"], input[data-index="option' + (index + 1) + '"]:checked');
          return input && variant.options[index] === input.value;
        });
      }
      function selectedVariant() {
        return variants.find(function (variant) { return matches(variant, size.value); });
      }
      function update() {
        Array.from(size.options).forEach(function (option) {
          if (!option.value) return;
          var available = variants.some(function (variant) { return matches(variant, option.value) && variant.available; });
          option.textContent = option.value + (available ? '' : ' — Sold out');
        });
        var selected = selectedVariant();
        // The existing theme handles Add to Bag and restock. Suppress express purchase
        // only when the size cannot be purchased, including a missing carried size.
        if (payment) payment.hidden = paymentWasHidden || !selected || !selected.available;
        var desired = size.value || requested;
        links.forEach(function (link) {
          var url = new URL(link.url);
          if (desired) {
            var candidates = link.variants.filter(function (variant) { return variant.options[link.sizeIndex] === desired; });
            var target = candidates.find(function (variant) { return variant.available; }) || candidates[0];
            url.searchParams.set('yfb_size', desired);
            if (target) url.searchParams.set('variant', target.id);
            else url.searchParams.delete('variant');
          }
          link.element.href = url.href;
        });
      }
      function remember() {
        requested = size.value || requested;
        var url = new URL(location.href);
        if (requested) url.searchParams.set('yfb_size', requested);
        var selected = selectedVariant();
        if (selected) url.searchParams.set('variant', selected.id);
        else url.searchParams.delete('variant');
        history.replaceState(history.state, '', url.href);
      }
      if (requested !== null) {
        if (!Array.from(size.options).some(function (option) { return option.value === requested; })) {
          var placeholder = document.createElement('option');
          placeholder.value = '';
          placeholder.textContent = 'Choose size';
          placeholder.disabled = true;
          size.insertBefore(placeholder, size.firstChild);
          size.value = '';
        } else {
          size.value = requested;
        }
        // Use the native theme's variant events, cart guard, and sold-out state.
        size.dispatchEvent(new Event('change', { bubbles: true }));
        remember();
      }
      form.addEventListener('change', function (event) {
        if (!event.target.matches('select[data-index], input[data-index]')) return;
        update();
        remember();
      });
      form.addEventListener('click', function (event) {
        var selected = selectedVariant();
        if (payment && payment.contains(event.target) && (!selected || !selected.available)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      window.addEventListener('pageshow', update);
      update();
    });
  });
})();
